import React from 'react';
import { Route, Routes, Link } from 'react-router-dom';
import './Admin.css'; // Import styles
import TFormDataList from './TFormDataList';
import SFormDataList from './SFormDataList';
import RFormDataList from './RFormDataList';

const Admin = () => {




    return (
        <div className="admin-container">
            <h2>Admin Dashboard</h2>
            <ul>
                <li><Link to='t'>خاطرات تشییع</Link></li>
                <li><Link to='s'>خاطرات سیل</Link></li>
                <li><Link to='r'>خاطرات رزمندگان</Link></li>

            </ul>
            <Routes>
                <Route path='t' element={<TFormDataList />} />
                <Route path='s' element={<SFormDataList />} />
                <Route path='r' element={<RFormDataList />} />
            </Routes>
        </div>


    );
};

export default Admin;
